import React from 'react';
import { Select, SelectItem } from '@heroui/react';

interface FilterMultiSelectProps {
  label: string;
  value: string; // comma-separated string
  options: Array<{ key: string; label: string }>;
  onChange: (value: string) => void; // receives comma-separated string
  className?: string;
}

export function FilterMultiSelect({ label, value, options, onChange, className = 'w-48' }: FilterMultiSelectProps) {
  // Parse comma-separated value into Set
  const selectedKeys = React.useMemo(() => {
    if (!value || value.trim() === '') {
      return new Set<string>([]);
    }
    const keys = value.split(',').map((k) => k.trim()).filter((k) => k !== '');
    return new Set(keys);
  }, [value]);

  return (
    <Select
      aria-label={`${label} filter`}
      className={className}
      label={label}
      selectedKeys={selectedKeys}
      selectionMode="multiple"
      size="sm"
      placeholder="Select..."
      onSelectionChange={(keys) => {
        const selectedArray = Array.from(keys as Set<string>);
        // Convert array to comma-separated string
        const valueString = selectedArray.length > 0 ? selectedArray.join(',') : '';
        onChange(valueString);
      }}
    >
      {options.map((option) => (
        <SelectItem key={option.key}>{option.label}</SelectItem>
      ))}
    </Select>
  );
}

export default FilterMultiSelect;

